import { useId } from 'react';

import './form-input.styles.scss';

const FormInput = ({ label, ...otherProps }) => {
  // L'intitulé doit rester le frère SUIVANT du champ : la remontée au focus passe
  // par `.form-input:focus ~ .form-input-label`. On les relie donc par un id
  // plutôt qu'en enveloppant le champ, ce qui casserait ce sélecteur.
  const inputId = useId();

  return (
    <div className="group">
      <input id={inputId} className="form-input" {...otherProps} />
      {label && (
        <label
          htmlFor={inputId}
          className={`${
            otherProps.value.length ? 'shrink' : ''
          } form-input-label`}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default FormInput;
